<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="11">
        <v-row
          justify="space-between"
          align="center"
        >
          <v-col cols="auto">
            <h2> Payroll Providers </h2>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="payrollProviders"
          :options.sync="options"
          :loading="loading"
          :items-per-page="5"
          :footer-props="{'items-per-page-options':[5, 10, 25]}"
          :server-items-length="serverCount"
          class="elevation-1"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getPayrollProviders } from '../services/payrollProviders';

export default {
  data() {
    return {
      headers: [
        { text: 'Name', align: 'start', value: 'name' },
        { text: 'Description', align: 'start', value: 'description' },
      ],
      payrollProviders: [],
      rowsPerPageItems: [5, 10, 10],
      options: {},
      loading: false,
      serverCount: 0,
    };
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
  async mounted() {
    await this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      const { data } = await getPayrollProviders(this.options?.page, this.options?.itemsPerPage);
      console.log(this.options);
      this.serverCount = data?.count;
      this.payrollProviders = data?.results;
      this.loading = false;
    },
  },
};
</script>

<style>

</style>
